import api from "../axios";

// add booking
export const addBookingApi = (data: any) => {
    return api.post("/booking/addbooking", data);
};

// add enquiry
export const addEnquiryApi = (data: any) => {
    return api.post("/booking/addenquiry", data);
};

// Branches
export const getBranchesApi = () => {
    return api.get("/booking/getbrancheslist");
};

// mobile number search

export const getCustomerApi = (mobileno: string, cityid: string) => {
    return api.get(
        `/booking/getcustomer?mobileno=${mobileno}&cityid=${cityid}`
    );
};

// locations
export const getLocationsApi = (cityid: string) => {
    return api.get(`/booking/getlocations?cityid=${cityid}`);
};

// vehicel type
export const getVehicleTypesApi = (cityid: string) => {
    return api.get(`/booking/getvehicletypes?cityid=${cityid}`);
};

// goods type
export const getGoodsTypesApi = () => {
    return api.get("/booking/getgoodstypes");
};

// trip
export const getTripTypesApi = () => {
    return api.get("/booking/gettriptypes");
};

// intercity list
export const getIntercityListApi = (vehicleid: string, cityid: string) => {
    return api.get(
        `/booking/getintercitylist?vehicletype=${vehicleid}&cityid=${cityid}`
    );
};

// return intercity list
export const getReturnIntercityApi = () => {
    return api.get("/booking/getreturnintercitylist");
};

// available cabs on duty - feeds the "Available Cab" panel on the Add page
export const getAvailableCabsApi = (branchid: string, vehicletype: string) => {
    return api.get("/booking/getcabsonduty", {
        params: { branchid, vehicletype },
    });
};

// getPackags base,km
export const getPackagesApi = (vehicleid: string, cityid: string) => {
    return api.get(
        `/booking/getpackages?vehicleid=${vehicleid}&cityid=${cityid}`
    );
};

// meter fare
export const getMeterFareApi = (
    distance: string,
    cityid: string,
    vehicleid: string
) => {
    return api.get(
        `/booking/getmeterfare?distance=${distance}&branchid=${cityid}&vehicleid=${vehicleid}`
    );
};

// nightFare
export const getNightFareApi = (vehicleid: string, cityid: string) => {
    return api.get(
        `/booking/getnightfare?vehicleid=${vehicleid}&cityid=${cityid}`
    );
};

// get enquiry by date
export const getEnquiryByDateApi = (branchid: string, fromdate: string, todate: string) => {
    return api.get(
        `/booking/getenquirybydate?branchid=${branchid}&fromdate=${fromdate}&todate=${todate}`
    );
};

// update enquiry
export const updateEnquiryApi = (data: any) => {
    const {
        isrefferal,
        iscv,
        isadditionalfare,
        istollgate,
        isgst,
        noofvechicles,
        ...bodyData
    } = data;

    const params: Record<string, any> = {};
    if (isrefferal !== undefined) params.isrefferal = isrefferal;
    if (iscv !== undefined) params.iscv = iscv;
    if (isadditionalfare !== undefined) params.isadditionalfare = isadditionalfare;
    if (istollgate !== undefined) params.istollgate = istollgate;
    if (isgst !== undefined) params.isgst = isgst;
    if (noofvechicles !== undefined) params.noofvechicles = noofvechicles;

    return api.post("/booking/updateenquiry", bodyData, { params });
};

// enquiry to new booking
export const enquiryToNewBookingApi = (data: any) => {
    return api.post("/booking/enquirytonewbooking", data);
};

export const getDistanceApi = (
    fromlat: string,
    fromlong: string,
    tolat: string,
    tolong: string
) => {
    return api.get(
        `/booking/getdistance?fromlat=${fromlat}&fromlong=${fromlong}&tolat=${tolat}&tolong=${tolong}`
    );
};

// get companies by city
export const getCompaniesApi = (cityid: string) => {
    return api.get(`/booking/getcompanieslist?cityid=${cityid}`);
};

// get booking by id for edit
export const getNewBookingEditApi = (bookingid: string) => {
    return api.get(`/booking/getNewbookingedit?bookingid=${bookingid}`);
};

// enquiry to assign trip
export const enquiryAssignTripApi = (data: any) => {
    return api.post("/booking/enquiryassigntrip", data);
};